<template>
  <div class="news-article-item">
    <div class="news-img">
      <img :src="item.url" :alt="truncatedTitle">
    </div>
    <div class="news-text">
      <router-link :to="{ name: 'news-content', params: { id: this.id } }">
        <h3>{{ truncatedTitle }}</h3>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  props: ["id"],
  name: "AppInfographicCard",
  data() {
    return {
      item: null,
      htmlContent: ""
    }
  },
  methods: {
    ...mapActions(["fetchContentById"]),
    loadData() {
      this.fetchContentById(this.id).then((contentResposnse) => {
        this.item.title = contentResposnse.title;
        this.htmlContent = contentResposnse.content;
      });
    },
  },
  computed: {
    ...mapGetters(["getContentById", "getSelectedLanguage"]),
    truncatedTitle() {
      return this.item.title.length > 100 ? this.item.title.substring(0, 100) + '...' : this.item.title;
    }
  },
  created() {
    this.item = this.getContentById(this.id);
    this.loadData();
  },
  watch: {
    getSelectedLanguage() {
      this.loadData();
    },
    '$route.params.id'() {
      this.loadData();
    }
  },
}
</script>

<style scoped>
.news-article-item {
  border: none;
  background-color: transparent;
  width: 100%;
}

.news-img {
  width: 100%;
  max-height: 250px;
  min-height: 250px;
}

.news-img img {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 250px;
  min-height: 250px;
}

.news-text {
  height: 60%;
  width: 100%;
  margin-top: 5%;
}

.news-text h3 {
  color: var(--main-color);
  height: 30%;
  font-size: 24px;
  /* letter-spacing: -1px; */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-tag {
  font-size: 12px !important;
  line-height: 18px !important;
  height: 5% !important;
  color: #757575;
  font-size: 18px;
  line-height: 20px;
}

.news-content-p {
  color: #757575;
  font-size: 18px;
  line-height: 20px;
  height: 30%;
  min-height: 65px;
}


.card-news-button {
  width: 100%;
  margin-top: 2%;
  border: 1px var(--main-color) solid;
  background-color: transparent;
  border-radius: 5px;
  color: var(--main-color);
  font-size: 18px;
  text-align: center;
}

.card-news-button a {
  color: var(--main-color);
  text-decoration: none;
}
</style>